import { render } from "./SummaryTableParametres.vue?vue&type=template&id=a9a9137a"
import script from "./SummaryTableParametres.vue?vue&type=script&lang=js"
export * from "./SummaryTableParametres.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__